export default "__VITE_ASSET__ByoGru6O__"